import { render } from "./Paginator.vue?vue&type=template&id=5d06adec"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=5d06adec&lang=css"
script.render = render

export default script